/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import Fab from "@material-ui/core/Fab";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import UserDefaultImg from "../../assets/images/default-picture.png";
import InstantConsultSmallLogo from "../../assets/images/logo-small.png";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import Zoom from "@material-ui/core/Zoom";
import ICInput from "../../components/form/input";
import { getChatMessageList, uploadChatFile } from "../../apiRoutes";
import MakeAPICall from "../../apiCalls/common";
import moment from "moment-timezone";
import _ from "lodash";
import DingBell from "../../assets/audios/note_sms.mp3";
import Button from "../../components/button";
import Link from "../../components/anchor";
import { ButtonDropdown } from "reactstrap";
import { CircularProgress } from "@material-ui/core";
import Model from "../../components/modal";
import socket from "../../utils/socket";
import Scroll from "react-scroll";

import EmojiInput from "../../components/emojiInput";
import EmojiTextInput from "../../components/emojiTextInput";

const Element = Scroll.Element;
const scroller = Scroll.scroller;

class ChatPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatText: "",
      apiCall: "",
      openChatBox: false, // open / close chat box
      response: false,
      messageText: "",
      disableSendMessageBtn: false,
      chatMessages: [],
      chatId: null,
      markChatAsReadDoctorObj: {
        chatWith: "Doctor",
        doctorId:
          props.userData && props.userData._id ? props.userData._id : null
      },
      uploadingChatFile: false,
      chatFileLargeModel: false,
      typingAdminFlg: false,
      doneTypingInterval: 900,
      adminTypingData: null,
      unreadChatCount: 0, // unread chat messsages
      msgInputValue: ""
    };
    this.inputUserProfilePic = createRef();
  }

  openChatBox = () => {
    this.setState({ openChatBox: !this.state.openChatBox });
    setTimeout(() => {
      this.scrollToLastMsg();
    }, 50);
  };

  closeChatBox = () => {
    this.setState({ openChatBox: false });
  };

  // For chat file upload
  handleFileInput = () => {
    this.inputUserProfilePic.current.click();
  };

  onChangeHandler = event => {
    this.setState({
      uploadingChatFile: true
    });
    let maxAllowedSize = 5 * 1024 * 1024,
      fileSizebig = false,
      bodyData = new FormData(),
      files = event.target.files;
    if (event.target.files && event.target.files[0]) {
      for (let i = 0; i < event.target.files.length; i++) {
        if (files[i].size > maxAllowedSize) {
          fileSizebig = true;
          break;
        } else {
          fileSizebig = false;
          let currentTime = new Date().toLocaleString();
          // files[i].name = currentTime + "_" + files[i].name;
          let attachingFile = new File(
            [event.target.files[i]],
            `${currentTime}_${event.target.files[i].name}`,
            { type: event.target.files[i].type }
          );
          bodyData.append("attachments[]", files[i]);
        }
      }
      if (fileSizebig) {
        this.setState({
          uploadingChatFile: false,
          chatFileLargeModel: true
        });
      } else {
        let apiCallParam = {
          reqType: "POST",
          reqURL: uploadChatFile,
          dataObj: bodyData,
          params: {},
          headers: {},
          successCallback: res => {
            if (res.data.data.length) {
              res.data.data.map((uploadFileUrl, index) => {
                let obj = {
                  doctorId: this.props.userData
                    ? this.props.userData._id
                    : null,
                  message: "",
                  author: this.props.userData
                    ? this.props.userData.firstName
                    : null,
                  userType: "Doctor",
                  attachmentUrl: uploadFileUrl || "",
                  attachmentName: uploadFileUrl.split("/").pop() || "",
                };
                socket.emit("sendMessage", obj);
              });
            } else {
              console.log("Something went wrong, Please try again !", res);
            }
            this.setState({
              uploadingChatFile: false
            });
          },
          failureCallback: err => {
            console.log("Something went wrong, Please try again ! ", err);
            this.setState({
              uploadingChatFile: false
            });
          },
          showPopUp: false
        };

        this.setState({
          apiCall: apiCallParam
        });
      }
    }
  };

  componentDidMount() {
    if (this.props.userData && this.props.userData._id) {
      let apiCallParam = {
        reqType: "GET",
        reqURL: getChatMessageList,
        dataObj: {},
        params: {
          doctorId: this.props.userData._id
        },
        headers: {},
        successCallback: res => {
          console.log("Chat Messages: ", res.data.data);
          this.setState({
            chatMessages: res.data.data.data,
            chatId: res.data.data.chatId,
            unreadChatCount:
              res.data.data && res.data.data.chat
                ? res.data.data.chat.adminCount
                : 0
          });
          this.scrollToLastMsg();
        },
        failureCallback: err => {
          console.log("Something went wrong. Please try again ", err);
        },
        showPopUp: false
      };
      this.setState({ apiCall: apiCallParam });
    }

    socket.on("connect", data => {
      this.setState({
        disableSendMessageBtn: false
      });
    });

    socket.on("doctorMessageDone", this.insertChatMessage);

    socket.on("doctorReadMsgError", data => {
      console.log("Something went wrong!, Please try again. ", data);
    });

    socket.on("disconnect", reason => {
      this.setState({
        disableSendMessageBtn: true
      });
    });

    socket.on("adminMessageDone", this.insertAdminChatMessage);

    socket.on("adminReadAllMsg", this.readDoctorChatMsg);

    socket.on("adminTypingStart", this.handleAdminTyping);
  }

  insertChatMessage = data => {
    console.log("Chat message inserted: ", data);
    if (data.status && data.data.chatId === this.state.chatId) {
      let chatData = data.data;
      this.setState(prevState => ({
        chatMessages: [...prevState.chatMessages, chatData]
      }));
      document.querySelector("#doctorInputChat").value = "";
      this.scrollToLastMsg();
    } else {
      console.log("Something went wrong : ", data);
    }
  };

  insertAdminChatMessage = data => {
    console.log("Admin Chat data: ", data);
    if (data.status && data.data.data.chatId === this.state.chatId) {
      this.setState({
        openChatBox: true
      });
      let chatData = data.data.data;
      this.setState(prevState => ({
        chatMessages: [...prevState.chatMessages, chatData],
        typingAdminFlg: false
      }));
      if (this.state.openChatBox) {
        socket.emit("doctorReadChat", this.state.markChatAsReadDoctorObj);
      }
      // this.setState({
      //   openChatBox: true
      // });
      this.playAudio();
      this.scrollToLastMsg();
      this.setState({
        unreadChatCount: 0
      });
    } else {
      console.log(
        "Something went wrong sfdgsdg ",
        data.status,
        data.data.data
      );
    }
  };

  scrollToLastMsg = () => {
    // let elmnt = document.getElementById("last-msg");
    // if (elmnt)
    //   elmnt.scrollIntoView();
    scroller.scrollTo("last-msg", {
      duration: 100,
      // delay: 30,
      // smooth: true,
      containerId: "messageContainer",
      offset: 300 // Scrolls to element + 100 pixels down the page
    });
  };

  handleSendMsg = event => {
    event.preventDefault();
    event.stopPropagation();
    if (document.querySelector("#doctorInputChat").value.trim() !== "") {
      let obj = {
        doctorId: this.props.userData ? this.props.userData._id : null,
        message: document.querySelector("#doctorInputChat").value.trim(),
        author: this.props.userData ? this.props.userData.firstName : null,
        userType: "Doctor"
      };
      socket.emit("sendMessage", obj);

      this.setState({
        msgInputValue: ""
      });
    }
  };

  handleKeyUp = event => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleSendMsg(event);
    }
  };

  // Doctor typing event
  handleKeyDown = event => {
    let obj = {
      chatId: this.state.chatId,
      doctorId: this.state.markChatAsReadDoctorObj.doctorId
    };
    socket.emit("doctorTyping", obj);
  };

  readDoctorChatMsg = data => {
    if (data.status && data.chatId === this.state.chatId) {
      let copyData = JSON.parse(JSON.stringify(this.state.chatMessages));
      copyData = _.map(copyData, e => {
        if (!e.fromAdmin) {
          e.readStatus = true;
        }
        return e;
      });
      this.setState({
        chatMessages: copyData
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    this.scrollToLastMsg();
    if (
      prevState.openChatBox !== this.state.openChatBox &&
      this.state.openChatBox
    ) {
      socket.emit("doctorReadChat", this.state.markChatAsReadDoctorObj);
      this.setState({
        unreadChatCount: 0
      });
      // this.scrollToLastMsg();
    }
  }

  playAudio() {
    try {
      const audioEl = document.getElementsByClassName("audio-element")[0];
      audioEl.play();
    } catch (e) {
      console.log("Audio Direct Play Not Allowed By System CatchBlock: ", e);
    }
  }

  closeFileLargeModel = () => {
    this.setState({
      chatFileLargeModel: false
    });
  };

  typingTimer = null;

  handleAdminTyping = data => {
    if (this.state.chatId === data.chatId) {
      this.setState({
        typingAdminFlg: true,
        adminTypingData: data
      });
      setTimeout(() => {
        this.scrollToLastMsg();
      }, 80);
    }
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(
      this.doneTyping,
      this.state.doneTypingInterval
    );
  };

  //user is "finished typing," do something
  doneTyping = () => {
    this.setState({
      typingAdminFlg: false
    });
  };

  handleMsgInputChange = event => {
    this.setState({
      msgInputValue: event.target.value
    });
  };

  handleEmojiInput = emoji => {
    this.setState({
      msgInputValue: (this.state.msgInputValue + " " + emoji).trim()
    });
  };

  render() {
    return (
      <div className="chat-parent-div">
        <span
          className={
            this.state.unreadChatCount
              ? "badge badge-light primary-color unread-chat-count"
              : "d-none"
          }
        >
          {this.state.unreadChatCount}
        </span>
        <Zoom in={!this.state.openChatBox}>
          <Fab
            size="medium"
            color="secondary"
            aria-label="add"
            className={this.state.openChatBox ? "d-none" : "chat-icon"}
            onClick={this.openChatBox}
          >
            <i className="fas fa-comment"></i>
          </Fab>
        </Zoom>
        <Zoom in={this.state.openChatBox}>
          <Fab
            size="medium"
            color="secondary"
            aria-label="add"
            className={this.state.openChatBox ? "chat-icon close" : "d-none"}
            onClick={this.openChatBox}
          >
            <i className="fas fa-times"></i>
          </Fab>
        </Zoom>
        <Zoom in={this.state.openChatBox}>
          <div className="chat-window">
            <div className="chat-header">
              <i
                className="fas fa-times cursor-pointer font-15"
                onClick={this.closeChatBox}
              ></i>
            </div>
            <div className="chat-body">
              <List className="chat-list" id="messageContainer">
                {this.state.chatMessages.map((value, index) => {
                  if (value.fromAdmin) {
                    return (
                      <React.Fragment key={value._id}>
                        <ListItem
                          id={
                            this.state.chatMessages.length - 1 === index
                              ? "last-msg"
                              : "chat-" + index
                          }
                          alignItems="flex-start"
                          className="from-admin pb-0"
                          key={index}
                        >
                          <ListItemAvatar>
                            <img
                              src={
                                value.imageUrl
                                  ? value.imageUrl
                                  : InstantConsultSmallLogo
                              }
                              alt="ic-user"
                              className="ic-user"
                            />
                          </ListItemAvatar>
                          <div className="admin-chat-min-width">
                            <div>
                              {value.author ? value.author + " " : ""}{" "}
                              {value.userType &&
                              value.userType !== "SUPPORT_STAFF"
                                ? "(Admin)"
                                : "(Support)"}
                            </div>
                            <div
                              className={
                                value.message === "" && value.attachmentUrl
                                  ? "chat-text attached-file"
                                  : "chat-text"
                              }
                            >
                              <React.Fragment>
                                {value.message === "" && value.attachmentUrl ? (
                                  value.attachmentUrl
                                    .split(".")
                                    .pop()
                                    .match(/jpg|jpef|png|gif/gi) ? (
                                    <a
                                      href={value.attachmentUrl}
                                      target="_blank"
                                    >
                                      <img
                                        src={value.attachmentUrl}
                                        className="img-thumbnail chat-attachment-img"
                                      />
                                    </a>
                                  ) : (
                                    <div className="chat-document-attached m-1 ml-0">
                                      <ButtonDropdown
                                        direction="down"
                                        className="w-100"
                                      >
                                        <Link
                                          title={
                                            value.attachmentUrl
                                              .split(".")
                                              .pop()
                                              .toLowerCase() === "pdf"
                                              ? "PDF"
                                              : "Other"
                                          }
                                          href={value.attachmentUrl}
                                          target="_blank"
                                          className={
                                            value.attachmentUrl
                                              .split(".")
                                              .pop()
                                              .toLowerCase() === "pdf"
                                              ? "consult-note-pdf-btn font-12"
                                              : "consult-note-pdf-btn font-12 Other-doc"
                                          }
                                        />
                                        <Button
                                          id="caret"
                                          title={"Document "}
                                          className="gray small pl-2 pr-0 m-0 text-left consult-note-btn font-12"
                                          clickEvent={() => {
                                            window.open(
                                              value.attachmentUrl,
                                              "_blank"
                                            );
                                          }}
                                        />
                                      </ButtonDropdown>
                                    </div>
                                  )
                                ) : (
                                  // value.message
                                  <span
                                    className="text-break"
                                    dangerouslySetInnerHTML={{
                                      __html: value.message.replace(
                                        /(?:\r\n|\r|\n)/g,
                                        "<br />"
                                      )
                                    }}
                                  ></span>
                                )}
                              </React.Fragment>
                            </div>
                          </div>
                        </ListItem>
                      </React.Fragment>
                    );
                  } else {
                    return (
                      <React.Fragment key={value._id}>
                        <ListItem
                          id={
                            this.state.chatMessages.length - 1 === index
                              ? "last-msg"
                              : "chat-" + index
                          }
                          alignItems="flex-start"
                          className="from-doctor pb-0"
                          key={index}
                        >
                          <div
                            className={
                              value.message === "" && value.attachmentUrl
                                ? "chat-text attached-file"
                                : "chat-text"
                            }
                          >
                            <React.Fragment>
                              {value.message === "" && value.attachmentUrl ? (
                                value.attachmentUrl
                                  .split(".")
                                  .pop()
                                  .match(/jpg|jpef|png|gif/gi) ? (
                                  <a href={value.attachmentUrl} target="_blank">
                                    <img
                                      src={value.attachmentUrl}
                                      className="img-thumbnail chat-attachment-img"
                                    />
                                  </a>
                                ) : (
                                  <div className="chat-document-attached m-1 ml-0">
                                    <ButtonDropdown
                                      direction="down"
                                      className="w-100"
                                    >
                                      <Link
                                        title={
                                          value.attachmentUrl
                                            .split(".")
                                            .pop()
                                            .toLowerCase() === "pdf"
                                            ? "PDF"
                                            : "Other"
                                        }
                                        href={value.attachmentUrl}
                                        target="_blank"
                                        className={
                                          value.attachmentUrl
                                            .split(".")
                                            .pop()
                                            .toLowerCase() === "pdf"
                                            ? "consult-note-pdf-btn font-12"
                                            : "consult-note-pdf-btn font-12 Other-doc"
                                        }
                                      />
                                      <Button
                                        id="caret"
                                        title={"Document "}
                                        className="gray small pl-2 pr-0 m-0 text-left consult-note-btn font-12"
                                        clickEvent={() => {
                                          window.open(
                                            value.attachmentUrl,
                                            "_blank"
                                          );
                                        }}
                                      />
                                    </ButtonDropdown>
                                  </div>
                                )
                              ) : (
                                // value.message
                                <span
                                  className="text-break"
                                  dangerouslySetInnerHTML={{
                                    __html: value.message.replace(
                                      /(?:\r\n|\r|\n)/g,
                                      "<br />"
                                    )
                                  }}
                                ></span>
                              )}
                            </React.Fragment>
                          </div>
                          <ListItemAvatar className="mt-0">
                            <img
                              src={
                                this.props.userData &&
                                this.props.userData.profilePic &&
                                this.props.userData.profilePic.original
                                  ? this.props.userData.profilePic.original
                                  : UserDefaultImg
                              }
                              alt="ic-user"
                              className="user-img"
                            />
                          </ListItemAvatar>
                        </ListItem>
                        <div className="chat-time-doctor" key={value._id}>
                          <p className="float-left mb-0">
                            {moment(value.createdAt)
                              .tz("Australia/Brisbane")
                              .format("LLL")}
                          </p>

                          <svg
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 16 15"
                            width="16"
                            height="15"
                            className={
                              value.readStatus
                                ? "float-right ml-2"
                                : "float-right ml-2"
                            }
                          >
                            <path
                              fill={value.readStatus ? "#f5ab35" : "#7f7f7f"}
                              d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"
                            ></path>
                          </svg>
                        </div>
                      </React.Fragment>
                    );
                  }
                })}

                <ListItem
                  alignItems="flex-start"
                  className={
                    this.state.typingAdminFlg ? "notify-typing" : "d-none"
                  }
                >
                  <div>
                    <strong className="float-left w-auto admin-typing-text">
                      {this.state.adminTypingData &&
                      this.state.adminTypingData.firstName
                        ? this.state.adminTypingData.firstName
                        : ""}{" "}
                      (
                      {this.state.adminTypingData &&
                      this.state.adminTypingData.userType
                        ? this.state.adminTypingData.userType !==
                          "SUPPORT_STAFF"
                          ? "Admin"
                          : "Support"
                        : ""}
                      )
                    </strong>
                    <div className="ticontainer">
                      <div className="tiblock">
                        <div className="tidot"></div>
                        <div className="tidot"></div>
                        <div className="tidot"></div>
                      </div>
                    </div>
                  </div>
                </ListItem>

                <ListItem
                  alignItems="flex-start"
                  className={this.state.uploadingChatFile ? "w-100" : "d-none"}
                >
                  <CircularProgress
                    disableShrink
                    className="primary-loader m-auto"
                  />
                </ListItem>
              </List>
            </div>
            <div className="chat-footer border-top">
              <Paper component="div" className="root">
                <EmojiTextInput
                  component={ICInput}
                  id="doctorInputChat"
                  name="doctorInputChat"
                  label=""
                  placeholder="Type here..."
                  className="input"
                  onKeyUp={this.handleKeyUp}
                  onKeyDown={this.handleKeyDown}
                  value={this.state.msgInputValue}
                  onChange={this.handleMsgInputChange}
                />
                <div style={{ paddingLeft: "10px", paddingTop: "5px" }}>
                  <EmojiInput onEmojiSelected={this.handleEmojiInput} />
                </div>
                <IconButton
                  type="button"
                  className="icon-button"
                  aria-label="search"
                  onClick={this.handleFileInput}
                >
                  <i className="fas fa-paperclip"></i>
                </IconButton>
                <Divider className="divider" orientation="vertical" />
                <IconButton
                  color="primary"
                  type="button"
                  className="icon-button"
                  aria-label="directions"
                  onClick={event => this.handleSendMsg(event)}
                  disabled={this.state.disableSendMessageBtn}
                >
                  <i
                    className={
                      this.state.disableSendMessageBtn
                        ? "fas fa-paper-plane"
                        : "fas fa-paper-plane primary-color"
                    }
                  ></i>
                </IconButton>
              </Paper>
            </div>
          </div>
        </Zoom>

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />

        {/* Audio element */}
        <audio className="audio-element d-none">
          <source src={DingBell}></source>
        </audio>

        {/* Hidden file input for custom desing */}
        <input
          type="file"
          id="file"
          accept="image/jpeg,image/gif,image/png,application/pdf"
          ref={this.inputUserProfilePic}
          style={{ display: "none" }}
          onChange={this.onChangeHandler}
        />

        <Model
          openModal={this.state.chatFileLargeModel}
          modalBodyContent="Selected file is too big!"
          okayText="Okay"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          okayEvent={this.closeFileLargeModel}
          cancelEvent={this.closeFileLargeModel}
        />
      </div>
    );
  }
}

// export default ChatPage;

const mapStateToProps = props => ({
  userData:
    props.auth && props.auth.user && props.auth.user.userData
      ? props.auth.user.userData
      : {}
});

const mapDispatchToProps = dispatch => ({});
export default connect(mapStateToProps, mapDispatchToProps)(ChatPage);
